import axiosInstance from "./AxiosInstance";

export function createPrescription(prescriptionData) {
  return axiosInstance.post("/admin/addPrescription", prescriptionData);
}

export function updatePrescription(prescriptionData) {
  return axiosInstance.post("/admin/updatePrescription", prescriptionData);
}

export function getSuggestedPrescription(prescriptionData) {
  return axiosInstance.post("/admin/suggestedPrescription", prescriptionData);
}

export function updateDuration(data) {
  return axiosInstance.post("/admin/updateDuration", data);
}

export function getPatientPrescriptions(prescriptionData) {
  return axiosInstance.post("/admin/getPatientPrescriptions", prescriptionData);
}

export function holdPatientMedicines(data) {
  return axiosInstance.post("/patient/medicineHold", data)
}

export function stopPatientPrescription(data) {
  return axiosInstance.post("/patient/prescriptionStop", data);
}